import { render, staticRenderFns } from "./AlertComponent.vue?vue&type=template&id=3d87fdec&scoped=true&"
import script from "./AlertComponent.vue?vue&type=script&lang=js&"
export * from "./AlertComponent.vue?vue&type=script&lang=js&"
import style0 from "./AlertComponent.vue?vue&type=style&index=0&id=3d87fdec&prod&lang=css&"
import style1 from "./AlertComponent.vue?vue&type=style&index=1&id=3d87fdec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d87fdec",
  null
  
)

export default component.exports